// This file will house the configured Axios instance for API calls.
import axios from 'axios';
import oktaAuth from '@/features/auth/services'; // Import the oktaAuth instance

const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add a request interceptor to include the Okta access token
apiClient.interceptors.request.use(
  async (config) => {
    const accessToken = oktaAuth.getAccessToken();
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/**
 * Constructs the full API endpoint path, including any configured prefix.
 * @param path The specific API path (e.g., '/contracts/search')
 * @returns The full API endpoint URL string.
 */
export const getApiEndpoint = (path: string): string => {
  const prefix = import.meta.env.VITE_API_URL_PREFIX || '';
  return `${prefix}/api${path}`;
};

export default apiClient;
